import React from "react";
import { useTranslation } from "react-i18next";
import { ICellRendererParams } from "@ag-grid-community/core";

import { GridTransaction, TransactionStatus, TransactionType } from "../../../../types";

import {
  InvoiceableIndicator,
  PaperFormIndicator,
  LinkedTransactions,
} from "../../..";
import { SubdirectoryArrow } from "../../../Icons";

import styles from "./TypeRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridTransaction;
  isStaffView?: boolean;
}

const TypeRenderer = ({ data, isStaffView = false }: Props) => {
  const { t } = useTranslation();

  const isLinkedTransactions = !!data.linkedTransactions?.length;
  const isWaitingReceipt =
    data.transactionType === TransactionType.Delivery &&
    data.statusCode === TransactionStatus.Synchronizing &&
    !isLinkedTransactions;

  return (
    <>
      <div className={styles.type}>
        {t(`transactions.type.${data.transactionType}`)}
        <PaperFormIndicator isPaperForm={data.isPaperForm} />
        {!isStaffView && (
          <InvoiceableIndicator isInvoiceable={data.isInvoiceable} />
        )}
      </div>
      {isLinkedTransactions && (
        <LinkedTransactions
          transactionType={data.transactionType}
          linkedTransactions={data.linkedTransactions}
          isStaffView={isStaffView}
        />
      )}
      {isWaitingReceipt && (
        <div className={styles.waitingReceiptRow}>
          <SubdirectoryArrow
            width={12}
            height={12}
            isUp={false}
            className={styles.waitingReceiptIcon}
          />
          <span className={styles.waitingReceiptLabel}>
            {t("transactions.details.waitingReceipt")}
          </span>
        </div>
      )}
    </>
  );
};

export default TypeRenderer;
